import EventInsights from './Insights';

export default EventInsights;